module.exports = __webpack_public_path__ + "img/5.310c30a3.jpg";